<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Áudios' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content class="noticia-play">
  <div class="gradient-extendido"></div>

  <div style="margin-top: -56px !important;">
    <audio-player [audioUrl]="audio.url" [nome]="audio.nome" [image]="image" [smallVersion]="false" *ngIf="audio.id">
    </audio-player>
  </div>

  <ion-list *ngFor="let a of audios;" style="padding: 10px 20px 0px 20px;">
    <ion-item class="list-item" (click)="openAudio(a);" lines="none">
      <ion-avatar slot="start">
        <img [src]="image | image:'evento'">
      </ion-avatar>

      <p class="conteudo-mensagem bold-1">{{a.nome}}</p>

      <ion-note slot="end">
        <i class="fas fa-volume-up icon-audio" *ngIf="a.id != audio.id"></i>
        <i class="fas fa-volume-up playing icon-audio" *ngIf="a.id == audio.id"></i>
      </ion-note>
    </ion-item>
  </ion-list>

  <ion-list *ngIf="audio.length == 0">
    <sem-registro></sem-registro>
  </ion-list>
</ion-content>